import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anonymous, obj = authed
  useEffect(() => {
    api.get("/auth/me")
      .then((r) => { setUser(r.data); })
      .catch(() => { setUser(false); });
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
    } catch (err) {
      console.warn("Failed to load profile after login:", err);
    }
    return r.data;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) { console.warn("Logout request failed (session may already be invalid):", err); }
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export { formatError };
